import React from 'react';
import PropTypes from 'prop-types';
import {Button, Modal} from 'react-bootstrap';
import {FaBell, FaCheckCircle, FaCreditCard, FaEuroSign, FaMapMarkerAlt, FaShieldAlt, FaUserFriends, FaUserPlus, FaVideo} from 'react-icons/fa';
import {useTranslation} from 'react-i18next';

const BookingGuideModal = ({show, onHide, context}) => {
  const {t} = useTranslation();
  const sections = [
    {icon: FaMapMarkerAlt, key: 'SLOT'},
    {icon: FaCreditCard, key: 'PAYMENT'},
    {icon: FaUserFriends, key: 'INVITATION'},
    {icon: FaUserPlus, key: 'PARTICIPANT'},
    {icon: FaEuroSign, key: 'CREDIT'},
    {icon: FaShieldAlt, key: 'RULES'},
    {icon: FaBell, key: 'ALERT'},
    {icon: FaVideo, key: 'VIDEO'}
  ];

  return (
    <Modal show={show} onHide={onHide} size="lg" scrollable className="partner-planning-guide-modal booking-guide-modal">
      <Modal.Header closeButton>
        <div className="partner-planning-guide-title">
          <span><FaUserFriends aria-hidden="true"/></span>
          <div><small>{t('BOOKING_GUIDE_PLAYER_PLANNER')}</small><Modal.Title>{t('BOOKING_GUIDE_TITLE')}</Modal.Title></div>
        </div>
      </Modal.Header>
      <Modal.Body>
        <div className="partner-planning-guide-intro">
          <strong>{t(context === 'invitation' ? 'BOOKING_GUIDE_INVITATION_INTRO' : 'BOOKING_GUIDE_INTRO')}</strong>
          <p>{t('BOOKING_GUIDE_DESCRIPTION')}</p>
        </div>
        <div className="partner-planning-guide-grid">
          {sections.map(({icon: Icon, key}, index) => (
            <section key={key} className="partner-planning-guide-card">
              <span className="partner-planning-guide-card-icon"><Icon aria-hidden="true"/></span>
              <div><small>{t('BOOKING_GUIDE_STEP', {number: index + 1})}</small><h5>{t(`BOOKING_GUIDE_${key}_TITLE`)}</h5><p>{t(`BOOKING_GUIDE_${key}_CONTENT`)}</p></div>
            </section>
          ))}
        </div>
        <div className="partner-planning-guide-check"><FaCheckCircle/><div><strong>{t('BOOKING_GUIDE_BEFORE_CONFIRM')}</strong><span>{t('BOOKING_GUIDE_BEFORE_CONFIRM_TEXT')}</span></div></div>
      </Modal.Body>
      <Modal.Footer><Button className="partner-planning-guide-confirm" onClick={onHide}><FaCheckCircle/> {t('UNDERSTOOD')}</Button></Modal.Footer>
    </Modal>
  );
};

BookingGuideModal.propTypes = {show: PropTypes.bool.isRequired, onHide: PropTypes.func.isRequired, context: PropTypes.string};
BookingGuideModal.defaultProps = {context: 'calendar'};

export default BookingGuideModal;
